import React from 'react';
import ReactDOM from 'react-dom';
import './app.scss';
import AppView from './app';
// import browserHistory from './Components/browserHistory';

ReactDOM.render(<AppView />, document.getElementById('root'));
